import { batchGeoResult, batchGeoStatus } from "api/layer";
import { AppAction } from "helpers/context";

export function pollingFunction(
  interval: any,
  batchId: string,
  dispatch: any,
  maxAttempts: number = 3
): Promise<any[] | undefined> {
  return new Promise((resolve, reject) => {
    let attempts = 0;

    const makeRequest = () => {
      const param = {
        batchId
      };

      attempts++;

      batchGeoStatus(param)
        .then((response) => {
          if (!response?.status) {
            console.error("接口响应出错，停止轮询：", response);
            clearInterval(intervalId);
            dispatch({ type: AppAction.setAddressEncoding, payload: false });
            dispatch({
              type: AppAction.addSnackBarParams,
              payload: {
                titleIconColor: "red",
                titleIcon: "warning",
                title: "errorTitle",
                message: "errorMessageAddress"
              }
            });
            reject(new Error("接口响应出错"));
            return;
          }
          if (!response.data?.isCompleted) {
            if (attempts >= maxAttempts) {
              console.warn(`达到最大尝试次数 ${maxAttempts}，停止轮询`);
              clearInterval(intervalId);
              reject(new Error(`达到最大尝试次数 ${maxAttempts}`));
            }
            return;
          }
          clearInterval(intervalId);
          batchGeoResult(param)
            .then((response) => {
              if (!response?.data?.batchGeoResults) {
                resolve(undefined);
                return;
              }
              resolve(response.data.batchGeoResults);
            })
            .catch((error) => {
              console.error(error);
              reject(error);
            });
        })
        .catch((error) => {
          console.error("请求出错，停止轮询：", error);
          clearInterval(intervalId);
          reject(error);
        });
    };
    const intervalId = setInterval(makeRequest, interval);
  });
}
